module.exports = __webpack_public_path__ + "static/img/96035A_X_08_20170524_LC.5588c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96035A_X_08_20170524_LC.png
// module id = A7tM
// module chunks = 0